'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
            'svg',
            {
                height: props.height,
                width: props.width,
                version: '1.1',
                viewBox: '0 0 24 24',
                xmlns: 'http://www.w3.org/2000/svg'
            },
            _react2.default.createElement(
                'g',
                { fill: 'none', fillRule: 'evenodd', stroke: 'none', strokeWidth: '1' },
                _react2.default.createElement('path', { d: 'M1 5h22v14.667H1z' }),
                _react2.default.createElement(
                    'g',
                    { fill: props.fill },
                    _react2.default.createElement('path', { d: 'M9.803 9.669l-1.001 5.717h1.602l1.003-5.717zM16.212 9.81a4.221 4.221 0 0 0-1.434-.24c-1.583 0-2.698.774-2.707 1.887-.01.82.796 1.28 1.402 1.553.624.28.834.46.83.71-.004.383-.496.558-.958.558-.64 0-.981-.087-1.507-.3l-.206-.091-.226 1.279c.376.16 1.066.298 1.785.305 1.683 0 2.776-.766 2.788-1.953.008-.65-.42-1.145-1.343-1.554-.56-.264-.905-.44-.9-.709 0-.237.29-.491.917-.491.524-.008.902.102 1.199.218l.143.066.217-1.238M20.322 9.675h-1.238c-.385 0-.672.101-.84.474l-2.379 5.24h1.683l.336-.86 2.052.003c.047.2.195.856.195.856h1.486l-1.295-5.713zm-1.976 3.685l.638-1.598c-.01.015.13-.331.212-.546l.108.493s.307 1.366.37 1.652h-1.328v-.001zM7.459 9.673l-1.569 3.9-.166-.793c-.292-.913-1.202-1.903-2.219-2.399l1.434 5.001 1.695-.002 2.522-5.707H7.459' }),
                    _react2.default.createElement('path', { d: 'M4.436 9.67H1.853l-.02.119c2.009.473 3.34 1.617 3.891 2.99l-.562-2.627c-.098-.362-.378-.47-.726-.482' })
                )
            )
        )
    );
};

Icon.propTypes = {
    fill: _propTypes2.default.string,
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Icon.defaultProps = {
    fill: '#00589F',
    width: '24px',
    height: '24px'
};

Icon.displayName = 'Visa';

exports.default = Icon;